// src/modules/leasecontrol/components/ConfirmDeleteDialog.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export default function ConfirmDeleteDialog({ open, onClose, onConfirm, loading, description, titulo = "Eliminar usuario" }) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent dividers>
        <Typography>{description || "¿Seguro que deseas eliminar este usuario?"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <LoadingButton loading={loading} color="error" variant="contained" onClick={onConfirm}>
          Eliminar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}